import { BordOneToneIcon, NudosMaskedNumberInput } from 'components/NudosComponents';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { IOrderPriceEditionForm } from '../../OrderPriceEdition.types';
import { CLIENT_PLAN_SUBSCRIPTIONS } from 'types/client.types';
import { VOLATILE_CURRENCIES } from 'utils/logisticServices.utils';
import { CURRENCIES } from 'types/bussines';
import { formatCost } from 'utils/formatNumbers';

import './OrderEditionHeader.scss';

interface IOrderEditionHeaderProps {
  companyName?: string;
  orderId?: number;
  exchangeRate?: number;
  currency?: string;
}

const OrderEditionHeader = ({ companyName, orderId, exchangeRate, currency }: IOrderEditionHeaderProps) => {
  const { control } = useFormContext<IOrderPriceEditionForm>();
  const levelSubscription = useWatch({ control, name: 'levelSubscription' });
  const isCurrencyUSD = currency === CURRENCIES.USD;
  const isVolatileCurrency = VOLATILE_CURRENCIES.includes(currency as CURRENCIES);

  return (
    <section className="orderEditionHeader">
      <div className="infoContainer">
        <div className="iconContainer">
          <BordOneToneIcon variant="dollarSign2" customWidth="20px" stroke={'white'} standardSize={20} />
        </div>
        <div className="orderInfo">
          <p className="orderInfoTitle">Edición del resumen de la orden</p>
          <p className="orderInfoText">
            <b>{companyName}</b>
            {levelSubscription && ` (${CLIENT_PLAN_SUBSCRIPTIONS[levelSubscription]}) `}
            <b>- Orden N°{orderId}</b>
          </p>
        </div>
      </div>
      {!isCurrencyUSD && (
        <div className="exchangeRate">
          Tasa de cambio:{' '}
          {isVolatileCurrency ? (
            <Controller
              name="exchangeRate"
              control={control}
              render={({ field }) => (
                <NudosMaskedNumberInput
                  isFilled
                  placeholder={`${exchangeRate ? exchangeRate : '0.00'} ${currency}`}
                  handleChange={evt => field.onChange(evt as string)}
                  currentValue={String(field.value)}
                  maskPrefix="$"
                  maskSufix={currency}
                  numberOfDecimals={2}
                />
              )}
            />
          ) : (
            <span>
              {exchangeRate ? formatCost(Number(exchangeRate)) : '0.00'} {currency}
            </span>
          )}
        </div>
      )}
    </section>
  );
};

export default OrderEditionHeader;
